export enum Role {
  Admin = 'Admin',
  User = 'User',
  Super_Admin = 'Super Admin',
}
